<script setup>
import {computed, ref} from 'vue';
import {Head, Link, router, usePage} from '@inertiajs/vue3';
import ApplicationMark from '@/Components/ApplicationMark.vue';
import Banner from '@/Components/Banner.vue';
import Dropdown from '@/Components/Dropdown.vue';
import DropdownLink from '@/Components/DropdownLink.vue';
import NavLink from '@/Components/NavLink.vue';
import ResponsiveNavLink from '@/Components/ResponsiveNavLink.vue';
import Help from "@/Components/Dashboard/Help.vue";
import ContactUs from "@/Components/Dashboard/ContactUs.vue";
import Intercom from "@intercom/messenger-js-sdk";
import Footer from "@/Components/Footer.vue";
import NewFooter from "@/Components/NewFooter.vue";

const page = usePage()

defineProps({
    title: String,
});

</script>

<template>
    <div>
        <Head :title="title" />

        <Banner />

        <div class="min-h-screen bg-gray-100">
            <nav :class="{'fixed': showingNavigationDropdown}" class="bg-white border-b border-gray-100 shadow w-full z-10  lg:w-auto lg:z-0">
                <!-- Primary Navigation Menu -->
                <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="flex justify-between h-16">
                        <div class="flex">
                            <!-- Logo -->
                            <div class="flex items-center">
                                <a href="/">
                                    <ApplicationMark class="block h-[24px] w-auto" />
                                </a>
                            </div>
                        </div>

                        <div class="hidden lg:flex sm:items-center sm:ms-6">
                            <div class="ms-3 relative">
                            </div>

                        </div>
                    </div>
                </div>

            </nav>


            <!-- Page Content -->
            <main class="flex justify-center p-4 lg:p-12">
                <slot></slot>
            </main>
        </div>
    </div>
    <NewFooter/>
</template>
